<template>
  <section class="rounded-lg bg-gray-100 p-4 md:p-5" data-cy="mapping-card">
    <header class="flex items-center justify-between">
      <h2 class="text-base font-semibold text-gray-900">Mapping</h2>
      <button
        v-if="canEdit"
        type="button"
        class="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:underline"
        data-cy="edit-mapping"
        @click="emit('edit')"
      >
        <i class="far fa-pen-to-square" aria-hidden="true" />
        Edit
      </button>
    </header>

    <dl class="mt-3 grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
      <template v-for="pair in shown" :key="pair.column">
        <dt class="truncate font-semibold text-gray-500" :title="pair.column">
          {{ pair.column }}
        </dt>
        <dd class="truncate text-gray-900" :title="pair.field_label">
          {{ pair.field_label }}
        </dd>
      </template>
    </dl>

    <p v-if="note" class="mt-3 text-sm text-gray-500" data-cy="mapping-note">
      {{ note }}
    </p>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { formatCount } from "@/DataImports/importsHubRows";
import { MAPPING_PREVIEW_COUNT, type MappingPair } from "./reviewBatch";

const props = defineProps<{ pairs: MappingPair[]; canEdit: boolean }>();
const emit = defineEmits<{ edit: [] }>();

const shown = computed(() => props.pairs.slice(0, MAPPING_PREVIEW_COUNT));
const hidden = computed(() => props.pairs.length - shown.value.length);
const note = computed(() =>
  [
    hidden.value > 0 && `And ${formatCount(hidden.value)} more.`,
    props.canEdit && "Editing the mapping reloads the file."
  ]
    .filter(Boolean)
    .join(" ")
);
</script>
